import React from 'react';
import './Features.css';

interface FeatureCardProps {
  icon: string;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <div className="features-card">
      <div className="features-card-icon">{icon}</div>
      <h3 className="features-card-title">{title}</h3>
      <p className="features-card-description">{description}</p>
    </div>
  );
};

const Features: React.FC = () => {
  const features = [
    {
      icon: '👆',
      title: 'Swipeable Discovery',
      description: 'Find new connections with an intuitive swipe interface that makes meeting people fun and effortless.'
    },
    {
      icon: '🎵',
      title: 'TikTok Integration',
      description: 'Seamlessly share and discover TikTok content, bringing your favorite videos into your social circle.'
    },
    {
      icon: '✨',
      title: 'Vibe Matching AI',
      description: 'Our smart algorithm connects you with people who truly match your lifestyle and interests.'
    },
    {
      icon: '💬',
      title: 'Chat for Real Connections',
      description: 'Engage in meaningful conversations with built-in messaging that keeps your connections strong.'
    },
    {
      icon: '📸',
      title: 'Lifestyle Feed',
      description: 'Share your moments and experiences with a vibrant feed that showcases your authentic self.'
    },
    {
      icon: '🔒',
      title: 'Privacy First',
      description: 'Your data and privacy are protected with industry-leading security measures.'
    }
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-heading">Features that Connect</h2>
          <p className="features-subheading">
            Everything you need to build meaningful connections and express your lifestyle
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
